import React, { useCallback, useMemo, type ReactElement } from 'react';

import { Select } from '@pushwoosh/dumb-components';

import { SUPPORTED_LANGUAGES, useLanguage } from '~/src/polyglot';

import { LanguageSelectBox } from './styles';

type LanguageOption = {
  value: string;
  label: string;
};

const OPTIONS: LanguageOption[] = SUPPORTED_LANGUAGES.map((language) => ({
  value: language.code,
  label: `${language.flag} ${language.nativeName}`,
}));

export function LanguageSelect(): ReactElement {
  const { language, setLanguage } = useLanguage();

  const value = useMemo(
    () => OPTIONS.find((option) => option.value === language) ?? null,
    [language],
  );

  const handleChange = useCallback(
    (option: LanguageOption | null) => {
      if (option) {
        setLanguage(option.value);
      }
    },
    [setLanguage],
  );

  return (
    <LanguageSelectBox>
      <Select<LanguageOption>
        width="180px"
        value={value}
        options={OPTIONS}
        onChange={handleChange}
        isSearchable
        menuPlacement="auto"
        // ~7.5 option rows: leaves the last row half-cut as a hint that the
        // list scrolls (we ship 14 languages).
        maxMenuHeight={270}
      />
    </LanguageSelectBox>
  );
}
